import { Button, Layout, theme, Form, Input, Spin, notification, Checkbox, InputNumber } from "antd";

import React, { useState, useCallback, useEffect } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import RecipeApi from "../../common/Apis/RecipeApi";
import AllergensApi from "../../common/Apis/AllergensApi";
import IngredientsApi from "../../common/Apis/IngredientsApi";
import DepartmentDropdown from "../../common/DropDowns/Department";
import ProductApi from "../../common/Apis/ProductApi";

const AddRecipe = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [formAdd] = Form.useForm();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const [loadings, setLoadings] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [refrigerated, Set_refrigerated] = React.useState(false);
  const [Allergens, setAllergens] = React.useState([]);
  const [Ingredient, setIngredient] = React.useState([]);
  const [filteredIngredients, setFilteredIngredients] = React.useState([]);
  
  // Function to extract group ID from batch code (number after # or just numeric part)
  const extractGroupId = (batchCode) => {
    if (!batchCode) return null;
    
    // First try to find pattern with # (e.g., T001T001A_ABC_Foods_#5555)
    const hashMatch = batchCode.match(/#(\d+)$/);
    if (hashMatch) {
      return hashMatch[1];
    }
    
    // If no #, try to extract numeric part from the end
    const numericMatch = batchCode.match(/(\d+)$/);
    if (numericMatch) {
      return numericMatch[1];
    }
    
    return null;
  };

  // Filter ingredients by grouping
  const filterIngredients = (ingredients) => {
    const grouped = {};
    const ungrouped = [];

    ingredients.forEach(ingredient => {
      const groupId = extractGroupId(ingredient.batchCode);
      
      if (groupId) {
        if (!grouped[groupId]) {
          grouped[groupId] = {
            id: ingredient.id,
            name: ingredient.name,
            batchCode: ingredient.batchCode,
            groupId: groupId,
            variants: [ingredient],
            displayName: ingredient.name,
            productId: ingredient.productDTO?.id
          };
        } else {
          grouped[groupId].variants.push(ingredient);
        }
      } else {
        ungrouped.push({
          ...ingredient,
          displayName: ingredient.name || ingredient.batchCode,
          productId: ingredient.productDTO?.id
        });
      }
    });

    // Convert grouped to array with display name
    const groupedArray = Object.values(grouped).map(group => ({
      id: group.id,
      name: group.displayName,
      batchCode: group.batchCode,
      originalName: group.name,
      groupId: group.groupId,
      variants: group.variants,
      isGrouped: true,
      productId: group.productId
  }));

    // Convert ungrouped to array
    const ungroupedArray = ungrouped.map(item => ({
      ...item,
      isGrouped: false
    }));

    return [...groupedArray, ...ungroupedArray];
  };

  const getAllergens = useCallback(async () => {
    try{
      const firstResponse = await AllergensApi.ListAllergensApi(0,10);
      const firstPageItems = firstResponse?.payloadDto || [];
      const totalPages = firstResponse?.totalPages || 1;

      if(totalPages <= 1) {
        setAllergens(firstPageItems);
        return;
      }

      const pageRequests = [];
      for (let page = 1; page < totalPages; page++) {
        pageRequests.push(AllergensApi.ListAllergensApi(page, 10));
      }

      const responses = await Promise.all(pageRequests);
      const allItems = [
        ...firstPageItems,
        ...responses.flatMap((res) => res?.payloadDto || []),
      ];

      setAllergens(allItems);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getIngredient = useCallback(async () => {
    try {
      const firstResponse = await IngredientsApi.ListIngredients(0, 10);
      const firstPageItems = firstResponse?.payloadDto || [];
      const totalPages = firstResponse?.totalPages || 1;

      let allItems = firstPageItems;

    if (totalPages > 1) {
      const pageRequests = [];
      for (let page = 1; page < totalPages; page++) {
        pageRequests.push(IngredientsApi.ListIngredients(page, 100));
      }

      const responses = await Promise.all(pageRequests);
      allItems = [
        ...firstPageItems,
        ...responses.flatMap((res) => res?.payloadDto || []),
      ];
    }

    setIngredient(allItems);
    setFilteredIngredients(filterIngredients(allItems));

    } catch (err) {
      console.log(err);
    }
  }, []);


  useEffect(() => {
    getAllergens();
    getIngredient();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [getAllergens, getIngredient]);

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      recipeName: data.productName,
      unit: data.unit,
      quantity: data.recipeQuantity,
      ingredientsDTO: Ingredients,
      institutionDTO: {
        id: data.institutionId
      },
      refrigeratedMeal: refrigerated,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    RecipeApi.CreateRecipe(formData)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Created</span>,
          description: "Created Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/recipe");
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const handleAddIngredients = () => {
    setIngredients([
      ...Ingredients,
      {
        id: "",
        quantity: "",
        unit: "",
        unitType: "",
        allergensDTO: "",
        unitAll: [],
      },
    ]);
  };

  const [Ingredients, setIngredients] = useState([
    {
      id: "",
      quantity: "",
      unit: "",
      unitType: "",
      allergensDTO: "",
      unitAll: [],
    },
  ]);

  const handleChangeQuantity = (ingredientsIndex, value) => {
  if (value < 0) return;

  setIngredients((prev) => {
    const next = [...prev];
    const row = { ...next[ingredientsIndex] };
    const product = row.product;          // per-row, not global

    let qtyInUOM3 = value;
    if (row.unitType === "UOM1") {
      qtyInUOM3 = value * product?.unitOfMeasurement2 * product?.unitOfMeasurement3;
    } else if (row.unitType === "UOM2") {
      qtyInUOM3 = value * product?.unitOfMeasurement3;
    }

    row.quantity = qtyInUOM3;
    next[ingredientsIndex] = row;
    return next;
  });
};

  const handleChangeUnit = (ingredientsIndex, value) => {
  setIngredients((prev) => {
    const next = [...prev];
    const row = { ...next[ingredientsIndex] };
    const product = row.product;          // per-row, not global

    const selectedUnitType =
      product?.unitUomOne === value ? "UOM1" :
      product?.unitUomTwo === value ? "UOM2" :
      product?.unitUomThree === value ? "UOM3" : null;

    row.unit = value;
    row.unitType = selectedUnitType;
    next[ingredientsIndex] = row;
    return next;
  });
};

  const handleChangeIngredient = (IngredientsIndex, value) => {
  const ingredientId = value.split("|")[0];
  const productId = value.split("|")[1];

  // 1. Update the row's ingredient id immediately
  setIngredients((prev) => {
    const next = [...prev];
    next[IngredientsIndex] = { ...next[IngredientsIndex], id: ingredientId };
    return next;
  });

  ProductApi.SingleProducts(productId)
    .then((response) => {
      const product = response?.payload;
      const allergenIds = (product?.allergens || []).map((item) => item.id);

      const unitAll = [
        product?.unitUomOne,
        product?.unitUomTwo,
        product?.unitOfMeasurement3 != 1 ? product?.unitUomThree : null,
      ].filter(Boolean);

      // 2. Update ALL row fields in ONE state call (fixes the overwrite bug)
      setIngredients((prev) => {
        const next = [...prev];
        next[IngredientsIndex] = {
          ...next[IngredientsIndex],
          id: ingredientId,
          product,                                   // per-row product (fixes cross-talk)
          allergensDTO: allergenIds.map((id) => ({ id })),
          unitAll,
        };
        return next;
      });

      // 3. Update the allergen form field
      formAdd.setFieldsValue({
        [`Allergen${IngredientsIndex}`]: allergenIds,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

  const handleChangeAllergens = (IngredientsIndex, value) => {
    const newIngredients = [...Ingredients];
    newIngredients[IngredientsIndex].allergensDTO = value.map(id => ({ id }));
    setIngredients(newIngredients);
  };

  const handleRemoveIngredients = (IngredientsIndex) => {
    const newIngredients = [...Ingredients];
    newIngredients.splice(IngredientsIndex, 1);
    setIngredients(newIngredients);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={formAdd}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col span={16}>
                  <Form.Item
                    name="productName"
                    label="Recipe Name :"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Product Name.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Recipe Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="unit"
                    label="Unit"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Unit",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-3"
                      placeholder="Select Unit"
                    >
                      <option value="Kg"> Kg</option>
                      <option value="G"> G</option>
                      <option value="L"> L</option>
                      <option value="ML"> ML</option>
                      <option value="BOX"> BOX</option>
                      <option value="PACKET"> PACKET</option>
                      <option value="PIECE"> PIECE</option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="recipeQuantity"
                    label="Quantity"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Quantity.",
                      },
                      {
                        validator: (_, value) => {
                          if (value < 0) {
                            return Promise.reject('Quantity cannot be negative');
                          }
                          return Promise.resolve();
                        }
                      }
                    ]}
                  >
                    <InputNumber
                      type="number"
                      placeholder="Quantity"
                      className="control-input"
                      style={{ width: '100%' }}
                      min={0}
                      step={0.01}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <DepartmentDropdown />
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="refrigerated"
                    className="text-lable"
                  >
                    <Checkbox
                      checked={refrigerated === true}
                      onChange={() => Set_refrigerated(!refrigerated)}
                    >
                      Is a refrigerated food
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24}>
                  <div>
                    <div className="d-flex py-3 pt-4">
                      <h5>Ingredients</h5>
                      <Button
                        className="mx-4 btn btn-primary my-0 py-1 px-4"
                        onClick={handleAddIngredients}
                      >
                        +
                      </Button>
                    </div>
                    {Ingredients.map((ingredient, ingredientsIndex) => (
                      <div key={ingredientsIndex}>
                        <Row gutter={16} className="mt-3">
                          <Col span={24}>
                            <div key={ingredientsIndex} className="d-flex align-items-center">
                              <h5 className="mb-0">Ingredient {ingredientsIndex + 1}</h5>
                              <Button
                                className="mx-4 btn btn-primary my-0 py-1 px-4"
                                onClick={() =>
                                  handleRemoveIngredients(ingredientsIndex)
                                }
                              >
                                -
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <div className="mx-4 py-2 Ingredients-New">
                          <Row gutter={16}>
                            <Col span={16}>
                              <Form.Item
                                name={`Ingredient${ingredientsIndex}`}
                                label={`Ingredient ${ingredientsIndex + 1}`}
                                className="text-lable "
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Ingredient.",
                                  },
                                ]}
                              >
                                {filteredIngredients && (
                                  <>
                                    <Select
                                      showSearch
                                      className="select-multi"
                                      placeholder="Select Ingredient"
                                      onChange={(value) =>
                                        handleChangeIngredient(
                                          ingredientsIndex,
                                          value
                                        )
                                      }
                                      filterOption={(input, option) => {
                                        // Access the children directly from the option
                                        const label = option?.children || '';
                                        return String(label).toLowerCase().includes(input.toLowerCase());
                                      }}
                                    >
                                      {filteredIngredients.map((option, index) => (
                                        <Select.Option 
                                          key={option.id} 
                                          value={option?.id + "|" + option?.productId}
                                        >
                                          {option.name}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </>
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16} className="pt-3">
                            <Col span={8}>
                              <Form.Item
                                name={`Ingredientunit${ingredientsIndex}`}
                                label="Unit"
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Unit",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select col-9"
                                  placeholder="Select Unit"
                                  onChange={(value) =>
                                    handleChangeUnit(
                                      ingredientsIndex,
                                      value
                                    )
                                  }
                                  options={ingredient?.unitAll.map((option, index) => ({
                                    value: option,
                                    label: option,
                                  }))}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={8}>
                              <Form.Item
                                name={`Quantity${ingredientsIndex}`}
                                label="Quantity"
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Quantity.",
                                  },
                                  {
                                    validator: (_, value) => {
                                      if (value < 0) {
                                        return Promise.reject('Quantity cannot be negative');
                                      }
                                      return Promise.resolve();
                                    }
                                  }
                                ]}
                              >
                                <InputNumber
                                  type="number"
                                  onChange={(value) =>
                                    handleChangeQuantity(
                                      ingredientsIndex,
                                      value
                                    )
                                  }
                                  placeholder="Quantity"
                                  className="control-input"
                                  style={{ width: '100%' }}
                                  min={0}
                                  step={0.01}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16} className="pt-2">
                            <Col span={16}>
                              <Form.Item
                                name={`Allergen${ingredientsIndex}`}
                                label="Allergen :"
                                className="text-lable pt-1 col-12"
                              >
                                {Allergens && (
                                  <>
                                    <Select
                                      mode="multiple"
                                      className="select-multi custom-select-New"
                                      placeholder="Select Allergens"
                                      onChange={(value) =>
                                        handleChangeAllergens(
                                          ingredientsIndex,
                                          value
                                        )
                                      }
                                      options={Allergens.map((option, index) => ({
                                        value: option?.id,
                                        label: option?.allergensName,
                                      }))}
                                    />
                                  </>
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
              <div
                className="d-flex justify-content-between pt-5"
                style={{
                  gap: "10px",
                }}
              >
                <Button
                  onClick={handleGoBack}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    fontWeight: 500,
                  }}
                >
                  Create {loadings && <Spin size="small" className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddRecipe;